var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M23.886,1.536C23.713,1.206,23.372,1,23,1H1C0.628,1,0.287,1.206,0.114,1.536 c-0.173,0.329-0.148,0.728,0.063,1.033L9,15.312V22c0,0.553,0.448,1,1,1h4c0.552,0,1-0.447,1-1v-6.688l8.822-12.743 C24.034,2.264,24.059,1.865,23.886,1.536z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }